import { todayMelb, addDays } from "@/lib/calendar";

export const fmtDue = (d) => (d ? `Due ${new Date(`${d}T00:00:00`).toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" })}` : "");

export function dueGroup(d) {
  if (!d) return "none";
  const t = todayMelb();
  if (d < t) return "past";
  if (d <= addDays(t, 6)) return "soon";
  return "upcoming";
}

export const DUE_GROUPS = [["soon", "Due this week"], ["upcoming", "Upcoming"], ["none", "No due date"], ["past", "Past due date"]];
